export default {
  name: 'TeamBanner',
  props: ['photo', 'site'],
  data() {
    return {

    }
  },
  methods: {
    goToPlace(link) {
      if(!this.$route.path.includes(link)){
        this.$router.push(`${link}`)
      }
    }
  }
}
